import { AplicacaoMonitoramentoDetalhado } from '../monitoramento/aplicacao-monitoramento-detalhado.model';
import { ConversorMonitoramento } from '../monitoramento/conversor-monitoramento.model';
import { ExtratorMonitoramento } from '../monitoramento/extrator-monitoramento.model';
import { IrisMonitoramento } from '../monitoramento/iris-monitoramento.model';
import { PrismaMonitoramento } from '../monitoramento/prisma-monitoramento.model';

export class Monitoramento {
  conversor = new AplicacaoMonitoramentoDetalhado<ConversorMonitoramento>('Conversor');
  extrator = new AplicacaoMonitoramentoDetalhado<ExtratorMonitoramento>('Extrator');
  iris = new AplicacaoMonitoramentoDetalhado<IrisMonitoramento>('Iris');
  prisma = new AplicacaoMonitoramentoDetalhado<PrismaMonitoramento>('Prisma');
}
